const stats = [
  { value: '1000万+', label: '累计用户', icon: 'ri-user-line' },
  { value: '500万+', label: '优质内容', icon: 'ri-file-text-line' },
  { value: '98.2%', label: '用户好评率', icon: 'ri-heart-line' },
  { value: '3000+', label: '合作伙伴', icon: 'ri-building-line' },
];

export default function StatsSection() {
  return (
    <section className="py-12 md:py-16 bg-primary-500">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-background-50/20 rounded-full">
                <i className={`${stat.icon} text-xl text-background-50 dark:text-foreground-950`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-heading font-bold text-background-50 dark:text-foreground-950 mb-1">
                {stat.value}
              </div>
              <div className="text-background-50/80 dark:text-foreground-950/80 text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}